import "spotlight.js";

class Lightbox{
    sources = [];

    constructor(){
        this.init();
    }

    init(){
        document.querySelectorAll("[data-lightbox-slider]").forEach((element, i) => {
            const sources = element.getAttribute("data-lightbox-slider").split(', ').map(src => {return { src }});

            element.addEventListener("click", () => {
                Spotlight.show(sources, {
                    theme: "white",
                    animation: "fade",
                    infinite: true,
                });
            });
        });
    }
}

new Lightbox();